import { useEffect } from 'preact/hooks'
import { lightboxAlt, lightboxUrl } from '../state/widget'
import { CloseIcon } from './Icons'

/**
 * Full-screen photo preview. Открывается через `lightboxUrl.value = '<url>'`,
 * закрывается ESC / click на backdrop / X. Внутреннее решение вместо
 * `<a target=_blank>` чтобы не светить токен/clientId в адресной строке
 * партнёрского сайта и дать UX как в нативных мессенджерах.
 */
export function Lightbox() {
	const url = lightboxUrl.value
	const alt = lightboxAlt.value
	const open = url !== null

	useEffect(() => {
		if (!open) return
		const onKey = (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				lightboxUrl.value = null
				lightboxAlt.value = ''
			}
		}
		document.addEventListener('keydown', onKey)
		return () => document.removeEventListener('keydown', onKey)
	}, [open])

	if (!open) return null

	const close = () => {
		lightboxUrl.value = null
		lightboxAlt.value = ''
	}

	return (
		<div
			class='sw-lightbox'
			role='dialog'
			aria-modal='true'
			onClick={close}
		>
			<button
				type='button'
				class='sw-lightbox-close'
				aria-label='Close preview'
				onClick={close}
			>
				<CloseIcon />
			</button>
			<img
				class='sw-lightbox-img'
				src={url ?? ''}
				alt={alt}
				onClick={(e) => e.stopPropagation()}
			/>
		</div>
	)
}
